import React from 'react'

const Button = ({text="Contáctanos",color="#ffff86",bgColor="#0d2334"}) => {
  return (
    <div className='w-max px-4 py-2 font-Bebas font-bold tracking-wide text-2xl md:text-3xl lg:text-4xl 2xl:text-5xl rounded-lg rounded-tl-none' style={{color:color, backgroundColor:bgColor, boxShadow:`-10px 10px 0px 0px ${color}`}}>{text}</div>
  )
}

export default Button